import { Tab } from 'react-bootstrap';
import React from 'react';
import app from 'srcJs/App';
import { Else, If, Then } from 'react-if';
import { IntercomTriggerIcon } from 'components/intercom/components/IntercomTriggerIcon';

var SupportContent = function SupportContent(_ref) {
  var supportInfo = _ref.supportInfo;

  if (!supportInfo) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Tab.Pane, {
    eventKey: "support"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled mb-0"
  }, /*#__PURE__*/React.createElement("li", {
    className: "menu-panel-section"
  }, /*#__PURE__*/React.createElement("span", {
    className: "menu-panel-link py-12p container container-lg-fluid fs-22"
  }, app.tForReact('base_menu', 'Technical support'))), /*#__PURE__*/React.createElement("li", {
    className: "menu-panel-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "menu-panel-link container container-lg-fluid d-flex flex-column align-items-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-auto"
  }, app.tForReact('base_menu', 'Support Chat')), /*#__PURE__*/React.createElement(If, {
    condition: supportInfo.isDisplayIntercom
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(IntercomTriggerIcon, {
    additionalClassName: "mt-2"
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("span", null, supportInfo.scheduleChatWeekdays), /*#__PURE__*/React.createElement("span", null, supportInfo.scheduleChatWeekend))))), /*#__PURE__*/React.createElement("li", {
    className: "menu-panel-section"
  }, /*#__PURE__*/React.createElement("a", {
    href: "mailto:".concat(supportInfo.email),
    className: "menu-panel-link container container-lg-fluid"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-auto"
  }, app.tForReact('base_menu', 'Mail')), /*#__PURE__*/React.createElement("span", null, supportInfo.email)))));
};

export { SupportContent };